import { recordError } from "@/services/record-error";

// The Express server renders the public content pages with React and embeds
// the query cache it rendered with (TanStack Query `dehydrate`) in
// <script id="__CONTENT_DATA__" type="application/json"> right after #root.
// main.jsx hydrates the shared query client from it before React attaches
// to the server markup. Returns null when the page was not server-rendered.
let serverContentState;

export function readServerContentState() {
  if (serverContentState !== undefined) return serverContentState;
  serverContentState = null;
  if (typeof document === "undefined") return null;
  const script = document.getElementById("__CONTENT_DATA__");
  if (!script) return null;
  try {
    serverContentState = JSON.parse(script.textContent || "null");
  } catch (error) {
    recordError(error, {
      source: "services/server-content-state",
      operation: "readServerContentState",
    });
    serverContentState = null;
  }
  return serverContentState;
}
